export const createNavbar = (element) => {
  const instance = {
    $element: null,
    $navbarToggle: null,
    $navbar: null,
    $searchToggle: null,
    isNavbarOpen: false,
    isDesktop: false,
    isMouseOverNavbar: false,
    isMouseOverToggle: false,

    init(element) {
      this.$element = jQuery(element);
      this.isDesktop = window.matchMedia("(min-width: 768px)").matches;

      // Cache DOM elements
      this.$navbarToggle = this.$element.find(".js-header-navbar-toggle");
      this.$navbar = this.$element.find(".js-header-navbar");
      this.$searchToggle = this.$element.find(".js-search-toggle");
      // Set up events
      this.setEventListeners();
      this.handleResize();
      jQuery(window).on("resize", () => this.handleResize());
    },

    setEventListeners() {
      if (this.isDesktop) {
        this.$navbarToggle.on("mouseenter", () => this.showNavbar());
        this.$navbarToggle.on("mouseleave", () => this.checkHideNavbar());

        this.$navbar.on("mouseenter", () => {
          this.isMouseOverNavbar = true;
        });

        this.$navbar.on("mouseleave", () => {
          this.isMouseOverNavbar = false;
          this.checkHideNavbar();
        });
      } else {
        this.$navbarToggle.on("click", () => this.toggleNavbar());

        jQuery(document).on("click", (event) => {
          if (
            !this.$navbar.is(event.target) &&
            this.$navbar.has(event.target).length === 0 &&
            !this.$navbarToggle.is(event.target) &&
            this.$navbarToggle.has(event.target).length === 0
          ) {
            this.hideNavbar();
          }
        });
      }
    },

    removeEventListeners() {
      this.$navbarToggle.off();
      this.$navbar.off();
      jQuery(document).off("click");
    },

    handleResize() {
      const isCurrentlyDesktop =
        window.matchMedia("(min-width: 768px)").matches;
      if (isCurrentlyDesktop !== this.isDesktop) {
        this.isDesktop = isCurrentlyDesktop;
        this.removeEventListeners();
        this.setEventListeners();
      }
    },

    toggleNavbar() {
      if (this.isNavbarOpen) {
        this.hideNavbar();
      } else {
        this.showNavbar();
      }
    },

    showNavbar() {
      if (!this.isNavbarOpen) {
        this.$navbar.fadeIn(100);
        this.isNavbarOpen = true;
      }
    },

    checkHideNavbar() {
      setTimeout(() => {
        if (!this.isMouseOverNavbar && !this.isMouseOverToggle) {
          this.hideNavbar();
        }
      }, 100);
    },

    hideNavbar() {
      if (this.isNavbarOpen) {
        this.$navbar.fadeOut(100);
        this.isNavbarOpen = false;
      }
    },

    addSearchToggleClickHandler(callback) {
      this.$searchToggle.on("click", callback);
    },

    toggleSearchBarToggler(isOpen) {
      if (isOpen) {
        this.$searchToggle.find(".js-open-icon").hide();
        this.$searchToggle.find(".js-close-icon").show();
      } else {
        this.$searchToggle.find(".js-open-icon").show();
        this.$searchToggle.find(".js-close-icon").hide();
      }
    },

    initMenuToggle() {
      // Handle menu section expand/collapse on mobile
      this.$element.on("click", ".js-menu-toggle-btn", (e) => {
        console.log("clicked");
        e.preventDefault();
        const $button = jQuery(e.currentTarget);
        const groupId = $button.data("group");
        const $section = this.$element.find(
          `.js-menu-section[data-group="${groupId}"]`
        );
        const $hiddenItems = $section.find(".js-menu-item-hidden");
        const $showText = $button.find(".js-show-text");
        const $hideText = $button.find(".js-hide-text");

        if ($hiddenItems.is(":visible")) {
          // Hide items
          $hiddenItems.hide();
          $showText.show();
          $hideText.hide();
        } else {
          // Show items
          $hiddenItems.show();
          $showText.hide();
          $hideText.show();
        }
      });
    },
  };

  instance.init(element);
  // Initialize menu toggle functionality
  instance.initMenuToggle();
  return instance;
};
